import styled from 'styled-components';

export const Img = styled.img`
  height: auto;
  width: 100%;
  border-radius: 4px;
  position: relative;
`;